import { toast } from "react-toastify";

const ImageHandler = (event) => {
  return new Promise((resolve, reject) => {
    try {
      // TO CHECK WHETHER THE IMAGE SIZE IS MORE THAN 10MB
      if (event.target.files && event.target.files[0].size >= 15e7) {
        toast.error("File size should not exceed 15MB");
        reject();
      } else {
        var fileName = event.target.files[0].name;
        var FT = event.target.files[0].type;
        var fSize = event.target.files[0].size;
        const items = {
          name: fileName,
          size: fSize,
          type: FT,
        };
        // CREATING AN IMAGE FILE
        var image = event.target.files[0];
        var slicedImage = image.slice(0, image.size);
        const newFile = new File([slicedImage], `${fileName}`, {
          type: `${image.type}`,
        });
        // RETURNING AN ARRAY, BECAUSE WE CAN PASS ONLY ONE PROP IN RESOLVE 
        resolve([items, newFile]);
      }
    } catch (error) {
      reject("Something went wrong");
    }
  });
};

export default ImageHandler;
